import type { LifecycleStage } from 'features/libra/lifecycle/lifecycleTypes'
import type { LibraTicket } from 'features/libra/ticket/libraTicketsApi'
import type { LibraWorkflow } from 'features/libra/workflow/workflowStepsApi'

export function makeTicket(overrides: Partial<LibraTicket> = {}): LibraTicket {
  return {
    id: 'ticket-1',
    workflowId: 'wf-ut',
    title: 'Ticket',
    fieldValues: {},
    inputProvenance: {},
    stepId: 'step-1',
    workflowComplete: false,
    version: 1,
    assessmentId: 'assessment-1',
    completedBy: null,
    createdBy: 'jane.smith@example.com',
    lastUpdatedBy: null,
    createdAt: '2026-07-12T10:00:00Z',
    updatedAt: '2026-07-28T10:00:00Z',
    tags: { organization: 'org-1', unit: 'unit-1', site: 'site-1' },
    ticketStatus: '',
    terminalTransitionBy: null,
    terminalTransitionAt: null,
    submittedForReviewBy: null,
    submittedForReviewAt: null,
    contributors: [],
    ...overrides,
  }
}

export function makeWorkflow(
  id: string,
  name: string,
  stages: LifecycleStage[] = []
): LibraWorkflow {
  return {
    id,
    name,
    steps: [],
    tags: {},
    showTicketProgress: false,
    stepIndices: new Map(),
    globalContext: {},
    lifecycleConfig:
      stages.length > 0 ? { stages, transitions: [] } : undefined,
  }
}
